import React from "react";
import { useNavigate } from "react-router-dom";
import { Button, Container, Stack, Title, Text } from "@mantine/core";
import { Home, ArrowLeft, AlertCircle } from "lucide-react";
import "./styles.scss";

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="not-found-page">
      <div className="not-found-page__background">
        <span className="not-found-page__glow not-found-page__glow--one" />
        <span className="not-found-page__glow not-found-page__glow--two" />
        <span className="not-found-page__glow not-found-page__glow--three" />
        <div className="not-found-page__grid-overlay" />
      </div>

      <Container size="md" className="not-found-page__container">
        <Stack align="center" gap="xl" className="not-found-page__content">
          <div className="not-found-page__icon-wrapper">
            <AlertCircle className="not-found-page__icon" />
          </div>

          <div className="not-found-page__text-content">
            <Title order={1} className="not-found-page__title">
              404
            </Title>
            <Title order={2} className="not-found-page__subtitle">
              Page Not Found
            </Title>
            <Text size="lg" className="not-found-page__description">
              Oops! The page you're looking for doesn't exist. It might have
              been moved, deleted, or you entered the wrong URL.
            </Text>
          </div>

          <Button
            size="lg"
            leftSection={<Home size={20} />}
            onClick={() => navigate("/d")}
            className="not-found-page__button"
          >
            Back to Dashboard
          </Button>
        </Stack>
      </Container>
    </div>
  );
};

export default NotFound;
